import styled from "styled-components";

const ReportCard = styled.div`
  text-align: center;
  margin-bottom: 1.3rem;
  .quick-reports {
    padding: 0 0 1rem;
    margin: 0 -0.5rem;
  }
  .image-item {
    padding: 0 0.5rem;
  }
  .Polaris-Box {
    margin-top: 0 !important;
    border-radius: 0.6rem;
    .Polaris-Text--root {
      margin-bottom: 1rem;
      display: block;
    }
    @media (min-width: 768px) {
      span {
        font-size: 2rem;
        &.card-title {
          font-size: 1rem;
        }
      }
    }
  }
`;
export default ReportCard;
